<template>
  <section>
    <qx-search-box
      ref="searchBox"
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {
  servicerSelectList,
} from 'api/service';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        serviceUserIdOptions: [], // 归属服务商
        stateOptions: [], // 产品状态
        authStateOptions: [], // 认证状态
        form: [
          { // 产品名称
            label: '产品名称',
            value: 'productName',
            type: 'input',
            placeholder: '请输入产品名称',
          },
          { // 服务电话
            label: '服务电话',
            value: 'serviceCall',
            type: 'input',
            placeholder: '请输入服务电话',
          },
          { // 服务地址
            label: '服务地址',
            value: 'address',
            type: 'input',
            placeholder: '请输入服务地址',
          },
          { // 归属服务商
            label: '归属服务商',
            value: 'serviceUserId',
            type: 'select',
            filterable: true,
            default: this.$route.query.serviceUserId ? Number(this.$route.query.serviceUserId) : -1,
            placeholder: '请输入归属服务商',
          },
          { // 产品状态
            label: '产品状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择产品状态',
          },
          { // 认证状态
            label: '认证状态',
            value: 'authState',
            type: 'select',
            default: -1,
            placeholder: '请选择认证状态',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.serviceUserId': function (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          if (this.$refs.searchBox) {
            this.$refs.searchBox.setVal('serviceUserId', Number(this.$route.query.serviceUserId));
            setTimeout(() => {
              this.$refs.searchBox.sub();
            }, 100);
          }
        });
      }
    },
  },
  activated () {
    if (this.$route.query.serviceUserId) {
      this.$nextTick(() => {
        if (this.$refs.searchBox) {
          this.$refs.searchBox.setVal('serviceUserId', Number(this.$route.query.serviceUserId));
          setTimeout(() => {
            this.$refs.searchBox.sub();
          }, 100);
        }
      });
    }
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const resServiceUserId = await servicerSelectList();
    this.searchBoxData.serviceUserIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...resServiceUserId,
    ];
    const enumsList = await getEnumList({
      codeType: 'CUSTOMER_AUTH_STATE,SYS_STATE_DESC',
    });
    this.searchBoxData.authStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
